import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { DateFormatType, formatDate } from 'views/utils/converter';
import { getPdfData } from 'views/utils/download';
import { SymbolDetailInfo } from 'views/utils/graphql/graphql';
import { ApplySymbolInput } from '../hooks';

export const useSymbolApplyConfirm = (
  symbolDetail: SymbolDetailInfo,
  amountRaw: number | null,
  formik: FormikProps<ApplySymbolInput>,
) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [pdfData, setPDFData] = useState<string>();

  useEffect(() => {
    getPdfData({
      ApplySymbolData: {
        Symbol: symbolDetail.Symbol,
        Amount: amountRaw!,
        TransferDate: formatDate(formik.values.transferDate, DateFormatType.Slash_yyyyMMdd),
      },
    }).then((data) => {
      setPDFData(data);
    });
  }, []);

  return {
    isChecked,
    setIsChecked,
    pdfData,
  };
};
